<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>批改管理</el-breadcrumb-item>
      <el-breadcrumb-item>批改列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row>
        <el-col>
          <el-button type="primary" @click="goAddpage" v-if="canLook == 1">添加</el-button>
        </el-col>
      </el-row>
     
      <el-table :data="catelist" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="id" prop="id" width="50px"></el-table-column> 
      
        <el-table-column label="提交图" width="300px">
          <template slot-scope="scope">
            <div class="img-list" v-if="Array.isArray(scope.row.picArrStr)">
              <el-image
                v-for="(url, idx) in scope.row.picArrStr"
                :key="idx"
                :src="url"
                fit="cover"
                class="thumb-img"
                :preview-src-list="scope.row.picArrStr"
              />
            </div>
          </template>
        </el-table-column>

        <el-table-column label="批改图" width="190px">
          <template slot-scope="scope">
            <div class="img-list" v-if="Array.isArray(scope.row.resultPicArrStr)">
              <el-image
                v-for="(url, idx) in scope.row.resultPicArrStr"
                :key="idx"
                :src="url"
                fit="cover"
                class="thumb-img"
                :preview-src-list="scope.row.resultPicArrStr"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注"   width="130px">
          <template slot-scope="scope">
            <el-row>
              备注： {{scope.row.beizhu}}
            </el-row>
            <el-row>
              评语： {{scope.row.piyu}}
            </el-row> 
          </template>
        </el-table-column>
        <el-table-column label="提交信息" prop="create_time" width="150px"> 
           <template slot-scope="scope">
            
            <el-row>
              提交人： {{scope.row.nickname}}
            </el-row>
            <el-row>
              创建： {{scope.row.create_time}}
            </el-row>
            <el-row>
              更新： {{scope.row.update_time}}
            </el-row> 
          </template>
        </el-table-column>
        <el-table-column label="光亮值" prop="gl_count" width="50px"> </el-table-column>

        <el-table-column label="状态" width="90px" >
          <!--status :0待审批，1待批改，2已批改，3已拒绝，4违规，-->
          <template slot-scope="scope">
            <el-button
              size="mini"
              :type="statusMap[scope.row.status] ? statusMap[scope.row.status].type : 'info'"
              round
            >
              {{ statusMap[scope.row.status] ? statusMap[scope.row.status].label : '未知状态' }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-check" v-if="scope.row.status == 0" size="mini" @click="stateChanged(scope.row.id, 1)">审核通过</el-button>
            <el-button type="warning" icon="el-icon-close" v-if="scope.row.status == 0" size="mini" @click="stateChanged(scope.row.id, 3)">审核拒绝</el-button>
            <el-button type="primary" icon="el-icon-edit" v-if="scope.row.status == 2" size="mini" @click="pigaiById(scope.row.id)">修改批改</el-button>
            <el-button type="primary" icon="el-icon-edit" v-if="scope.row.status == 1" size="mini" @click="pigaiById(scope.row.id)">批改</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="removeById(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="querInfo.page"
        :page-sizes="[3, 5, 10, 15]"
        :page-size="querInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // 状态映射：不同状态显示不同按钮背景颜色
      statusMap: {
        0: { label: '待审核', type: 'info' },
        1: { label: '待批改', type: 'warning' },
        2: { label: '已批改', type: 'success' },
        3: { label: '已拒绝', type: 'danger' },
        4: { label: '违规', type: 'danger' }
      },
      canLook: 1,
      total: 0,
      // 查询条件
      querInfo: {
        page: 1,
        page_size: 10
      },
      catelist: [],  
    }
  },
  created () {
    this.getList()
  },
  methods: {

    // 根据Id删除对应的用户信息
    async removeById (id) {
      // 弹框询问用户是否删除数据
      const confirmResult = await this.$confirm(
        '此操作将删除该批改记录, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已取消删除')
      }
      const { data: res } = await this.$http.post('admin/pigai/delete', { id: id })
      if (res.code !== 200) {
        return this.$message.error('删除批改记录失败！')
      }
      this.$message.success('删除批改记录成功！')
      this.getList()
    },

    // 状态切换：当 status 为 3（拒绝）时，弹窗输入拒绝理由并提交
    async stateChanged (id, status) {
      console.log(id, status)
      if (Number(status) === 3) {
        try {
          const { value } = await this.$prompt('请输入拒绝理由', '审核拒绝', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPlaceholder: '请填写拒绝说明',
            inputType: 'textarea',
            inputValidator: (val) => {
              if (!val || !String(val).trim()) return '请输入拒绝理由'
              return true
            }
          })
          const refuseTxt = String(value).trim()
          const { data: res } = await this.$http.post('/admin/pigai/changeStatus', {
            status: status,
            id: id,
            refuseTxt
          })
          if (res.code !== 200) {
            return this.$message.error('更新状态失败！')
          }
          this.$message.success('已拒绝并提交理由')
          this.getList()
        } catch (e) {
          // 取消或出错
          this.$message.info('已取消操作')
        }
        return
      }

      // 其他状态，直接提交
      const { data: res } = await this.$http.post('/admin/pigai/changeStatus', {
        status: status,
        id: id
      })
      if (res.code !== 200) {
        return this.$message.error('更新状态失败！')
      }
      this.$message.success('更新状态成功！')
      this.getList()
    },

    // 获取活动列表数据
    async getList () {
       
      const { data: res } = await this.$http.get('admin/pigai/list', {
        params: this.querInfo
      })

      if (res.code !== 200) {
        return this.$message.error('获取活动列表失败！')
      }

      console.log(res.result)
      // 把数据列表，赋值给 catelist
      this.catelist = res.result.list
      // 为总数据条数赋值
      this.total = res.result.total
     
    },
    // 监听 pagesize 改变
    handleSizeChange (newSize) {
      this.querInfo.page_size = newSize
      this.getList()
    },
    // 监听 pagenum 改变
    handleCurrentChange (newPage) {
      this.querInfo.page = newPage
      this.getList()
    },

    // 点击按钮，展示添加分类的对话框
    showAddCateDialog () {
      this.addCateDialogVisible = true
    },

    // 新建
    goAddpage () {
      this.$router.push('/goods/addActivity')
    },

    // 编辑
    pigaiById (id) {
      this.$router.push({ path: '/pigaiDetail', query: { id: id } })
    },
  }
}
</script>

<style lang="less" scoped>
.treeTable {
  margin-top: 15px;
}

.tip{
  font-size:18px;
  color:#666666;
}

.el-cascader {
  width: 100%;
}

.img-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.thumb-img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
